import clsx from 'clsx'
import React from 'react'

import useStyles from './styles'

interface StatusOptionProps {
  id: string
  statuses: Array<APIUserStatus>
  loaded: boolean
  noStatusLabel?: string
  rootClass?: string
  onClick?: CallableFunction
}
const StatusOption: React.FC<StatusOptionProps> = ({
  id,
  statuses,
  loaded,
  noStatusLabel = 'NO STATUS',
  rootClass,
  onClick
}) => {
  const handleOnClick = React.useCallback(() => {
    onClick && onClick()
  }, [onClick])
  const stat = React.useMemo(() => {
    if (loaded) {
      return statuses.find(status => status.id === id)
    }
    return null
  }, [loaded, id, statuses])

  const classes = useStyles({ colour: stat?.colour })

  if (!stat) return <div>{noStatusLabel}</div>

  return (
    <div className={clsx(classes.foundRoot, rootClass)} onClick={handleOnClick}>
      <div className={classes.dot} />
      <label>{stat?.name}</label>
    </div>
  )
}

export default StatusOption
